import { PaymentMethodType } from '@features/invoicingSettings/enums/paymentMethodType'

import { paymentMethodTypeToFormField } from '../constants/paymentMethodTypeToFormField'
import type { DisplayedPaymentMethods } from '../types/invoiceForm/displayedPaymentMethods'

// Restores the form fields from the payment methods stored on a document. The inverse of
// filterDisplayedPaymentMethods: a method absent from the document was turned off by the user,
// so the stored list wins over the defaults rather than being merged with them.
//
// `stripeCardPayment` is deliberately left at its default: it reflects the organization-wide
// PayNow status, so no document can turn it on or off.
export const getDisplayedPaymentMethods = (
  paymentMeans: { type: PaymentMethodType }[] = [],
  defaults: DisplayedPaymentMethods = {},
): DisplayedPaymentMethods => {
  const displayedPaymentMethods: DisplayedPaymentMethods = {
    ...defaults,
    bank: false,
    offlinePayment: false,
    paypal: false,
  }

  for (const { type } of paymentMeans) {
    const formField = paymentMethodTypeToFormField[type]

    if (formField) {
      displayedPaymentMethods[formField] = true
    }
  }

  return displayedPaymentMethods
}
